import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SPINNER } from 'ngx-ui-loader';
import { AuthenticationService } from './service/authentication.service';
import { ApiService } from './service/api.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    spinner = SPINNER;
    mobile
    constructor(
        private translate: TranslateService,
        private auth: AuthenticationService,
        public dataStorageService: ApiService
    ) {
        /* init i18n module */
        translate.setDefaultLang(localStorage.getItem('userLocale') || 'en');
        if (this.isAuth() === true) {
        }
        let agent = navigator.userAgent;
        agent = agent.toLowerCase()
        if (agent.includes("android") || agent.includes("iphone")) {
            this.mobile = true
        } else {
            this.mobile = false
        }
    }

    isAuth() {
        var me = this;
        var token = false
        if (localStorage.getItem("currentUser")) {
            var token = !!JSON.parse(localStorage.getItem("currentUser")).token
            me.auth.user = JSON.parse(localStorage.getItem("currentUser"))
        }
        return token;
    }
    isMobile() {
        return this.mobile
    }
}
